import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import React, { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { ElementName, SmartLinkDirection, SmartLinkSize } from '../../../../../constants';
import { getBaseStyles, getGapSize, highlightRemoveStyles, renderChildren } from '../utils';
var getBlockStyles = function getBlockStyles(direction, size) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  justify-content: flex-start;\n  [data-separator] + [data-separator]:before {\n    content: '\u2022';\n    margin-right: ", "rem;\n  }\n  // Pull request elements: source branch \u2192 target branch\n  [data-smart-element='", "']\n    + [data-smart-element='", "']:before {\n    content: '\u2192';\n  }\n  // Pull request elements: target branch \u2190 source branch\n  [data-smart-element='", "']\n    + [data-smart-element='", "']:before {\n    content: '\u2190';\n  }\n"])), getBaseStyles(direction, size), highlightRemoveStyles, getGapSize(size), ElementName.SourceBranch, ElementName.TargetBranch, ElementName.TargetBranch, ElementName.SourceBranch);
};

/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */
var Block = function Block(_ref) {
  var children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? SmartLinkDirection.Horizontal : _ref$direction,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SmartLinkSize.Medium : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block' : _ref$testId,
    overrideCss = _ref.overrideCss,
    blockRef = _ref.blockRef,
    onRender = _ref.onRender,
    onTransitionEnd = _ref.onTransitionEnd;
  useEffect(function () {
    onRender && onRender();
  }, [onRender]);
  return jsx("div", {
    css: [getBlockStyles(direction, size), overrideCss],
    "data-smart-block": true,
    "data-testid": testId,
    onTransitionEnd: onTransitionEnd,
    ref: blockRef
  }, renderChildren(children, size));
};
export default Block;